import { render, staticRenderFns } from "./ConfigFeeitemForm.vue?vue&type=template&id=2a33fcc8&scoped=true&"
import script from "./ConfigFeeitemForm.vue?vue&type=script&lang=js&"
export * from "./ConfigFeeitemForm.vue?vue&type=script&lang=js&"
import style0 from "./ConfigFeeitemForm.vue?vue&type=style&index=0&id=2a33fcc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a33fcc8",
  null
  
)

export default component.exports